import React from "react";
import cx from "classnames";
import dayjs from "dayjs";
import styles from "./Banner.module.scss";

export interface BannerProps {
  formattedPhone: string;
}

declare let portalbannerSettings: string;

export const PortalBanner = () => {
  const bsetting = portalbannerSettings
    ? portalbannerSettings.split("~")
    : null;
  if (bsetting === null) return null;

  const showBanner =
    bsetting.length > 0 &&
    bsetting[0] === "publish" &&
    dayjs(bsetting[2]).add(1, "day").isAfter(dayjs());
  if (showBanner) {
    return (
      <div
        className={cx(styles.banner, styles[bsetting[1]])}
        dangerouslySetInnerHTML={{
          __html: bsetting[3].replace(/&lt;/g, "<").replace(/&gt;/g, ">"),
        }}
      />
    );
  } else {
    return null;
  }
};
